import React from 'react';
import LayoutContainer from './Container';
import Application from './UNApplication';
import '../styles/maincontent.css';

const UN = () => {
  const petitionURL = "https://petition.parliament.uk/petitions/660652";

  return (
    <LayoutContainer>
      <div className="main-content">
        <div className="content-row align-items-center">
          <a href={petitionURL} target="_blank" rel="noopener noreferrer" className="qr-image-container">
            <img src="images/qr-code.jpg" alt="QR Code" className="img-fluid qr-col" />
          </a>
          <h1 className="left-title">Application to UN CRPD Committee</h1>
        </div>
        {/* UN Application */}
        <Application />
      </div>
    </LayoutContainer>
  );
}

export default UN;

